module.exports = __webpack_public_path__ + "static/img/Gacha16.1bff00f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/defult/img/gasha/Gacha16.png
// module id = Vcye
// module chunks = 1